module.exports = __webpack_public_path__ + "static/media/Moon-00.01bf25a8.png";